var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-menu',_vm._g(_vm._b({attrs:{"content-class":_vm.mergedContentClass},scopedSlots:_vm._u([(_vm.$scopedSlots.activator)?{key:"activator",fn:function(slotProps){return [_vm._t("activator",null,null,slotProps)]}}:null],null,true)},'v-menu',_vm.menuAttrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }